import React from 'react'

import { Shimmer } from '@wartek-id/shimmer'

const ViewAksiNyataPlaceholder = () => {
  return (
    <>
      <div className="pb-5 px-4 mb-4 border-b border-subdued">
        <div className="flex mb-4">
          <Shimmer height={106} width={106} />
          <div className="ml-6 flex-auto">
            <Shimmer
              className="mb-2"
              height={16}
              noOfLines={2}
              style={{ width: '100%' }}
            />
            <Shimmer height={10} noOfLines={1} style={{ width: '100%' }} />
          </div>
        </div>
        <Shimmer height={46} style={{ width: '100%' }} />
      </div>
      <div>
        <div className="px-4 mb-4 pb-5 px-4 border-b border-subdued">
          <Shimmer className="mb-2" height={16} width={120} />
          <div className="flex items-center">
            <Shimmer height={48} width={48} rounded />
            <div className="ml-3 flex-auto">
              <Shimmer height={16} style={{ width: '100%' }} />
            </div>
          </div>
        </div>
        <div className="px-4 mb-4 pb-5 border-b border-subdued">
          <div className="mb-6">
            <Shimmer className="mb-4" height={16} style={{ width: '100%' }} />
            <Shimmer
              className="mb-2"
              height={16}
              noOfLines={4}
              style={{ width: '100%' }}
            />
          </div>
          <div className="mb-6">
            <Shimmer className="mb-4" height={16} style={{ width: '100%' }} />
            <Shimmer
              className="mb-2"
              height={16}
              noOfLines={4}
              style={{ width: '100%' }}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default ViewAksiNyataPlaceholder
